
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: 'white',
    padding: '1%',
    fontSize:'14px'
  },

  items: {
    padding: '1%',
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '10%',
  },

  item_body: {
    padding: '6px ',
  },

  main_header: {
    textAlign:'left',
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#ddd',
  },
  sub_header: {
    borderBottom:'2px solid',
    textAlign:'left',
    fontSize:'20px',
    fontWeight:'bold',
    marginBottom:'15px',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
    fontSize:'14%',
  },

  input: {
    width: '50%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionRegistration/style.js